module.exports = __webpack_public_path__ + "img/horizontal_4_3_pp3_3009.0554c585.png";